import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import karwan from "../images/karvaan.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../authmanager/authcontext";
import Navbar from "../navbar/navbar";
import { BASE_URL, fetchCategories, fetchProducts } from "../utils/utils";
import { CartContext } from "../cart/cart";
const ProductDetails = ({toggleTheme}) => {
  const { isLoggedIn, handleLogout, backHomeClick } = useContext(AuthContext);
  const {
    addToCart,
    cartItems,
    showCartItems,
    removeProductByQuantityFromCart,
    finalizeCart,
  } = useContext(CartContext);
  const { id, quantity } = useParams();
  const [selectedQuantity, setSelectedQuantity] = useState(quantity || 1);
  const [loading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [product, setProduct] = useState(null);
  const [categories, setCategories] = useState("");
  const navigate = useNavigate();
  console.log("Cart", cartItems);
  const accessToken = localStorage.getItem("accessToken");
  const handleQuantityChange = (e) => {
    setSelectedQuantity(e.target.value);
  };
  const decrementQuantity = () => {
    if (selectedQuantity > 1) {
      setSelectedQuantity(selectedQuantity - 1);
    }
  };

  const incrementQuantity = () => {
    setSelectedQuantity(selectedQuantity + 1);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        if (accessToken) {
          const productsData = await fetchProducts(accessToken, id);
          setProduct(productsData[0]); // Assuming the API returns a single product object
        }
      } catch (error) {
        setError("Failed to fetch product details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]); // Fetch product details whenever the ID changes

  const handleAddToCart = () => {
    addToCart(product, selectedQuantity);
  };
  const handleRemoveByQuantitytoCart = () => {
    removeProductByQuantityFromCart(product, 1);
    navigate(`/products/${id}`);
  };
  return (
    <div>
      {isLoggedIn ? (
        <div>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>{error}</p>
          ) : product ? (
            <div>
              <Navbar toggleTheme={toggleTheme}handleLogout={handleLogout} finalizeCart={finalizeCart} />
              <br></br>
              <div className="product-grid">
                <img
                  src={BASE_URL + product.image}
                  alt={product.name}
                  style={{ maxWidth: "100px" }}
                />
                {/* <p>Product ID: {product.id}</p> */}
                <p>Name: {product.name}</p>
                <p>Description: {product.description}</p>
                <p>Price: {product.price}</p>
                {/* <p>Category: {categories.name}</p> */}
                <div className="button-container">
                  <button className="circle" onClick={handleAddToCart}>
                    Add to Cart
                  </button>

                  {/* Conditionally render the Remove button */}
                  {showCartItems(product) ? (
                    <button
                      className="circle"
                      onClick={() => handleRemoveByQuantitytoCart()}
                    >
                      Remove
                    </button>
                  ) : (
                    ""
                  )}
                </div>

                <div className="quantity-input-container">
                  <button className="quantity-btn" onClick={decrementQuantity}>
                    <FontAwesomeIcon icon={faMinus} />
                  </button>
                  <input
                    type="number"
                    className="quantity-input"
                    placeholder="Quantity"
                    value={selectedQuantity}
                    onChange={handleQuantityChange}
                  />
                  <button className="quantity-btn" onClick={incrementQuantity}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
                <div className="button-container">
                  <div className="circle">
                    <span>{`Selected :-${showCartItems(product)}`}</span>
                  </div>
                </div>
                <Link to="/home">Back</Link>
              </div>
              {/* <button onClick={() => handleAddToCart()}>Add to Cart</button> */}
            </div>
          ) : (
            <p>No product details available.</p>
          )}
        </div>
      ) : (
        <div className="login-link">
          <div className="circle">
            <Link className="login-link" to="/login">
              Please login via{" "}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
